import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import { ActionHelper } from '../helpers';

@Service()
export class OnyxStorageService {
  protected readonly http = inject(HttpClient);

  public getFile(uuid: string): Observable<File> {
    return this.http
      .get(uuid, { observe: 'response', responseType: 'blob' })
      .pipe(
        map((response) => {
          if (!response.body) throw new Error('No file found');

          const blob = response.body;
          const fileName = response.headers
            .get('content-disposition')
            ?.split('filename=')[1]
            .split(';')[0];

          return new File([blob], fileName || '', { type: blob.type });
        }),
      );
  }

  public showPreview(target: Blob | MediaSource): void {
    ActionHelper.openLink(URL.createObjectURL(target));
  }
}
